// Central social media links for Jozori.
// Update these URLs once and they propagate across the site.

export const SOCIAL = {
  instagram: {
    href: "https://instagram.com/jozori",
    label: "@jozori",
    handle: "@jozori",
  },
  tiktok: {
    href: "https://tiktok.com/@jozori",
    label: "@jozori",
    handle: "@jozori",
  },
  facebook: {
    href: "https://facebook.com/jozori",
    label: "Jozori",
    handle: "Jozori",
  },
} as const;
